import { Router } from '@angular/router';
import { UntypedFormBuilder } from '@angular/forms';
import { UntypedFormGroup, AbstractControl } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { VALIDATORS } from 'src/environments/validators';
import { RegistrationService } from 'src/app/services/registration-service/registration.service';

@Component({
    selector: 'app-resend-mail-screen',
    templateUrl: './resend-mail-screen.component.html',
    styleUrls: ['./resend-mail-screen.component.css'],
    standalone: false
})
export class ResendMailScreenComponent implements OnInit {
    resendMailForm: UntypedFormGroup;

    email: AbstractControl;

    constructor(
        private formBuilder: UntypedFormBuilder,
        private registrationService: RegistrationService,
        private router: Router,
        private dialogService: DialogService
    ) {
        this.resendMailForm = formBuilder.group({
            email: ['', VALIDATORS.email]
        });
        this.email = this.resendMailForm.controls['email'];
    }

    onSubmit() {
        let username = this.email.value.toLowerCase();
        this.registrationService
            .resendMail(username)
            .then(() => {
                this.dialogService
                    .openDialog(
                        'Aktivierungsmail erneut gesendet',
                        'Die Aktivierungsmail wurde erneut gesendet und wird innerhalb der nächsten Minuten ankommen. ' +
                            'Nach erfolgreicher Aktivierung können Sie sich einloggen und auf ihren Account zugreifen.'
                    )
                    .subscribe(() => {
                        this.router.navigate(['']);
                    });
            })
            .catch(() => {});
    }

    public onCancel(): void {
        this.router.navigate(['']);
    }

    ngOnInit() {}
}
